import { Quote, Star } from "lucide-react";

export default function Testimonial() {
    return (
        <section
            data-testid="testimonial"
            className="bg-eclipse-light py-20 sm:py-28"
        >
            <div className="container-eclipse max-w-4xl text-center">
                <div className="flex justify-center mb-6">
                    <Quote
                        className="w-14 h-14 text-eclipse-cta"
                        strokeWidth={1.25}
                    />
                </div>

                <div
                    className="flex justify-center gap-1 mb-8"
                    data-testid="testimonial-stars"
                >
                    {Array.from({ length: 5 }).map((_, i) => (
                        <Star
                            key={i}
                            className="w-5 h-5 fill-eclipse-cta text-eclipse-cta"
                        />
                    ))}
                </div>

                <blockquote
                    data-testid="testimonial-quote"
                    className="font-display font-medium text-xl sm:text-2xl lg:text-3xl text-eclipse-primary leading-relaxed mb-10"
                >
                    “Eclipse Cubiertas resolvió la cubierta de nuestro
                    estacionamiento corporativo en tiempo récord. La calidad
                    del material y el acabado profesional superaron nuestras
                    expectativas. Sin duda los recomendamos.”
                </blockquote>

                <div className="inline-flex flex-col items-center">
                    <div className="w-12 h-px bg-eclipse-cta mb-4" />
                    <p
                        data-testid="testimonial-author"
                        className="font-display font-bold text-eclipse-primary text-sm sm:text-base"
                    >
                        Lic. Roberto Hernández
                    </p>
                    <p className="text-sm text-eclipse-muted">
                        Director de Operaciones · Grupo Industrial Regio
                    </p>
                </div>
            </div>
        </section>
    );
}
